const ufeApi = require('services/api/ufeApi');
const cookieUtils = require('utils/Cookies');
const Location = require('utils/Location');

function getPersonalizedPromotions(profileId, isUS) {
    const { isBeautyOffersEnabled, sdnUfeAPIUserKey, sdnDomainBaseUrl } = Sephora.configurationSettings;

    const showMLPromos = isBeautyOffersEnabled && isUS;

    const DYN_USER_ID = cookieUtils.read(cookieUtils.KEYS.DYN_USER_ID);
    const DYN_USER_CONFIRM = cookieUtils.read(cookieUtils.KEYS.DYN_USER_CONFIRM);
    const prodSdnDomainBaseUrl = 'https://api-developer.sephora.com';
    const prodSdnUfeAPIUserKey = 'nQc7BFt78yJBvfYDKtle9APd5RrX984i';
    const sdnDomainBaseUrlForBeautyOffers = Location.isOffersPage() && Location.isPreviewEnvironment();
    const sdnApiKey = sdnDomainBaseUrlForBeautyOffers ? prodSdnUfeAPIUserKey : sdnUfeAPIUserKey;
    const params = `${profileId}/${DYN_USER_ID}/${DYN_USER_CONFIRM}`;
    const ML_URL = `${sdnDomainBaseUrlForBeautyOffers ? prodSdnDomainBaseUrl : sdnDomainBaseUrl}/v1/beauty-offers/${params}`;

    const url = showMLPromos ? ML_URL : '/api/users/profiles/current/promotions?includeBCCData=true';

    const options = {
        method: 'GET',
        headers: showMLPromos
            ? {
                'X-Api-Key': sdnApiKey
            }
            : {}
    };
    const getPromosData = data => (showMLPromos ? data.data : data);

    return ufeApi.makeRequest(url, options).then(data => (data.errorCode ? Promise.reject(data) : getPromosData(data)));
}

module.exports = { getPersonalizedPromotions };
